import { Comment } from "./Comment";
import { User, newUser } from "./User";

export type Answer = {
    id: number;
    questionId: number;
    body: string;
    author: User;
    createdAt: string;
    updatedAt: string;
    votes: number;
    userVote: number;
    accepted: boolean;
    comments: Comment[];
};

export function newAnswer(author = newUser(), questionId = -1, body = ""): Answer {
    const ans: Answer = {
        id: -1,
        questionId: questionId,
        body: body,
        author: author,
        createdAt: "2020-01-01",
        updatedAt: "2020-01-01",
        votes: 0,
        userVote: 0,
        accepted: false,
        comments: [],
    };
    return ans;
}
